import { IbRepoVerificationReasonEnum } from 'src/app/ReusableComponent/block-time-report/enums/ib-repo-verification-reason.enum';
import { IBlockTimeItem } from 'src/app/ReusableComponent/block-time-report/block-time-report.model';

/**
 * Tells if the actual total must not include the IB repo hours, with the same rule as the server total.
 * While the IB repo waits for verification, only the measured hours of an airport mismatch count.
 */
export function isIbRepoHoursExcluded(
  record: Pick<IBlockTimeItem, 'ibRepoAwaitingVerification' | 'ibRepoVerificationReason'> | null,
): boolean {
  return Boolean(record?.ibRepoAwaitingVerification) && record?.ibRepoVerificationReason !== IbRepoVerificationReasonEnum.AirportMismatch;
}
